export function usePaystack() {
  function loadPaystack() {
    return new Promise((resolve, reject) => {
      if (window.PaystackPop) {
        resolve(window.PaystackPop);
        return;
      }
      const script = document.createElement("script");
      script.src = "https://js.paystack.co/v1/inline.js";
      script.onload = () => resolve(window.PaystackPop);
      script.onerror = () => reject(new Error("Failed to load Paystack"));
      document.body.appendChild(script);
    });
  }

  async function payWithPaystack({
    key,
    email,
    amount,
    currency,
    ref,
    subaccount = null,
    onSuccess,
    onClose,
  }) {
    await loadPaystack();
    const handler = window.PaystackPop.setup({
      key,
      email,
      amount: amount * 100,
      currency,
      ref,
      ...(subaccount ? { subaccount } : {}),
      callback: (response) => {
        if (response.status === "success") {
          onSuccess(response);
        } else {
          onClose({ onClose: true });
        }
      },
      onClose: () => {
        onClose({ onClose: true });
      },
    });
    handler.openIframe();
  }

  return { payWithPaystack };
}